export default __webpack_public_path__ + "static/media/ether.f2866991.png";